









































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import WeedSearch from '@/app/components/WeedAlarm/WeedSearch.vue'
import WeedListHeader from '@/app/components/WeedAlarm/WeedListHeader.vue'
import WeedList from '@/app/components/WeedAlarm/WeedList.vue'
import ReloadModal from '@/app/components/Common/ReloadModal.vue'
/* api */
import WeedAlarmListApi from '@/app/model/api/weedAlarmListApi'
/* module */
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import Local from '@/app/module/local'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    WeedSearch,
    WeedListHeader,
    ReloadModal,
    WeedList
  }
})
export default class weedAlarm extends Vue {
  /* データ */
  private totalCount: string|number = '-'
  private weedAlarmData: any = {}
  private alertText: string = ''
  private alertMessage: string = this.$store.state.alertState.message
  private reloadMessage: string = '<p>機械貸出の登録済みとなります。</p><p>画面を再度読み込み直してください。</p>'
  /* 表示非表示 */
  private notDataMessage: boolean = false
  private showServerErrorModal: boolean = false
  private showLoading: boolean = true
  private showReloadModal: boolean = false

  created () {
    this.getWeedAlarmList()
  }

  /* 初期表示 */
  private getWeedAlarmList () {
    (async () => {
      const result = await WeedAlarmListApi.getWeedAlarmList()

      if (result.isOk()) {
        this.weedAlarmData = result.getPayload().results
        this.totalCount = result.getPayload().total_count
        // ヘッダー表示用
        const weedAlarmCount = {
          timestamp: Date.now(),
          total_count: result.getPayload().total_count
        }
        await Local.setWeedAlarmCount(JSON.stringify(weedAlarmCount))
        this.$store.commit('weedState/setTotalCountFlag', true)

        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }
}
